import { AppBar, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import { Box } from "@mui/system";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import DeviceAlerts from "./DeviceAlerts";
import LockList from "./lockgateway/LockList";
import styles from "../smartdevicedetails.module.css";
import DoorLockcontroller from "./doorlock/controller";
import TTDoorLockcontroller from "./doorlock/ttlock-controller";
import TTDoorLockcontrollerPin from "./doorlock/ttlock-controller-pin";
import TTDoorLockcontrollerFingerprint from "./doorlock/ttlock-controller-fingerprint";
import TTDoorLockKeyFob from "./doorlock/ttlock-key-fob";
import Dimmercontroller from "./dimmer/controller";
import Thermostatcontroller from "./thermostat/controller";
import { RefreshCw } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import { toast } from "react-smart-toaster";
import DeviceAlertsMobile from "./DeviceAlertsMobile";
import { useEffect } from "react";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

const SimpleTabs = ({ deviceDetails, setLoading, setSnackbarMsg, setSnackbarOpen, setDeviceDetails, smartDeviceData, ttLockDeviceData }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);
    const [noOfSync, setNoOfSync] = useState(0);
    const [active, setActive] = useState(null);

    useEffect(() => {
        if (deviceDetails?.product_type === "Propertydek-Lock Gateway") {
            setTabValue(2);
        } else {
            if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-controlpanel:read") > -1) {
                setTabValue(0);
            } else if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-alert:read") > -1) {
                setTabValue(1);
            } else {
                setTabValue(3);
            }
        }

    }, [deviceDetails?.product_type, isAuthenticated, user]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }

    const syncTTLData = async () => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(`${process.env.REACT_APP_DEVICE_API_URL}v1/ttlock/sync-ttl-data/${deviceDetails?.id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);
            setSnackbarMsg(response?.data?.message);
            setSnackbarOpen(true);

            setNoOfSync(prev => prev + 1);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const toggle = (name) => {
        setActive((prev) => (prev === name ? null : name));
    }


    //For TTLock Doorlock
    const [allPasswordList, setAllPasswordList] = useState([]);
    const [keyList, setKeyList] = useState([]);
    const [fingerPrintList, setFingerPrintList] = useState([]);

    useEffect(() => {
        const getList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/lock-passcodes/" + deviceDetails?.id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setAllPasswordList(response.data.data);
            }).catch((error) => {
                setAllPasswordList([]);
            });
        }

        if (deviceDetails?.id && deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") {
            getList();
        }

    }, [deviceDetails?.id, deviceDetails?.product_type, deviceDetails?.device_type, getAccessTokenSilently, noOfSync]);

    useEffect(() => {
        const getList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/lock-key-fobs/" + deviceDetails?.id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setKeyList(response.data.data);
            }).catch((error) => {
                setKeyList([]);
            });
        }

        if (deviceDetails?.id && deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") {
            getList();
        }

    }, [deviceDetails?.id, deviceDetails?.product_type, deviceDetails?.device_type, getAccessTokenSilently]);

    useEffect(() => {
        const getList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/get-finger-prints/" + deviceDetails?.id, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setFingerPrintList(response.data.data);
            }).catch((error) => {
                setFingerPrintList([]);
            });
        }

        if (deviceDetails?.id && deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") {
            getList();
        }

    }, [deviceDetails, deviceDetails?.product_type, deviceDetails?.device_type, getAccessTokenSilently, noOfSync]);

    return (<div className={classes.root}>
        <div className={`${styles.BigTab}`}>
            <AppBar position="static">
                <Tabs value={tabValue} onChange={handleChange} aria-label="simple tabs example">
                    {(isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-controlpanel:read") > -1) && (deviceDetails?.product_type !== "Propertydek-Lock Gateway") && <Tab label="Control Panel" value={0} {...a11yProps(0)} />}
                    {(deviceDetails?.product_type === "Propertydek-Lock Gateway") && <Tab label="Associated Locks" value={2} {...a11yProps(2)} />}
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("device-alert:read") > -1 && <Tab label="Device Alerts" value={1} {...a11yProps(1)} />}
                </Tabs>
            </AppBar>
            <TabPanel value={tabValue} index={0}>
                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<button className={`${styles.syncLockBU}`} onClick={(e) => syncTTLData()}><RefreshCw /> sync</button>)}
                {(deviceDetails?.product_type === "Propertydek-Door Lock") && <div className={`${styles.ControllerBigRow}`}>
                    <div className={`${styles.ControllerCard}`}>
                        <p className={`${styles.Title}`}>Device Controller</p>
                        <div className={`${styles.ControllerBody}`}>
                            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "Tuya" && smartDeviceData?.status?.length) && (<DoorLockcontroller smartDeviceData={smartDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)}></DoorLockcontroller>)}
                            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontroller ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)}></TTDoorLockcontroller>)}
                        </div>
                    </div>
                    <div className={`${styles.ControllerCard}`}>
                        <p className={`${styles.Title}`}>Pin Codes</p>
                        <div className={`${styles.ControllerBody}`}>
                            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontrollerPin ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} noOfSync={noOfSync} allPasswordList={allPasswordList} />)}
                        </div>
                    </div>
                    <div className={`${styles.ControllerCard}`}>
                        <p className={`${styles.Title}`}>Fingerprints</p>
                        <div className={`${styles.ControllerBody}`}>
                            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontrollerFingerprint ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} noOfSync={noOfSync} fingerPrintList={fingerPrintList} setFingerPrintList={setFingerPrintList.bind(this)} />)}
                        </div>
                    </div>
                    <div className={`${styles.ControllerCard}`}>
                        <p className={`${styles.Title}`}>Key Fobs</p>
                        <div className={`${styles.ControllerBody}`}>
                            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockKeyFob setLoading={setLoading.bind(this)} deviceDetails={deviceDetails} noOfSync={noOfSync} keyList={keyList} setKeyList={setKeyList.bind(this)} />)}
                        </div>
                    </div>
                </div>}
                {deviceDetails?.product_type === "Propertydek-Light" && smartDeviceData?.status?.length && <div className={`${styles.ControllerBigRow}`}>
                    <div className={`${styles.ControllerCardDimmer}`}>
                        <p className={`${styles.Title}`}>Device Controller</p>
                        <div className={`${styles.ControllerBody}`}>
                            <Dimmercontroller smartDeviceData={smartDeviceData}></Dimmercontroller>
                        </div>
                    </div>
                </div>}
                {deviceDetails?.product_type === "Propertydek-Thermostat" && smartDeviceData?.status?.length && <div className={`${styles.ControllerBigRow}`}>
                    <div className={`${styles.ControllerCardDimmer}`}>
                        <p className={`${styles.Title}`}>Device Controller</p>
                        <div className={`${styles.ControllerBody}`}>
                            <Thermostatcontroller smartDeviceData={smartDeviceData}></Thermostatcontroller>
                        </div>
                    </div>
                </div>}
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <DeviceAlerts deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setDeviceDetails={setDeviceDetails.bind(this)} />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <LockList deviceDetails={deviceDetails} />
            </TabPanel>
        </div>

        <div className={`${styles.SmallTab}`}>
            {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<button className={`${styles.syncLockBU}`} onClick={(e) => syncTTLData()}><RefreshCw /> sync</button>)}
            {(deviceDetails?.product_type === "Propertydek-Door Lock") && <>
                <div className={`${styles.AccordionList}`}>
                    <div className={`${styles.AccordionListHead} ${active === "one" ? styles.Open : ""}`} onClick={() => toggle("one")}>
                        <p className={`${styles.Title}`}>Device Controller</p>
                        <img src="/static/img/downTriangle.svg" alt="" />
                    </div>
                    <div className={`${styles.AccordionListBody} ${active === "one" ? styles.Open : ""}`}>
                        <div className={`${styles.AccouFormGroup}`}>
                            <div className={`${styles.ControllerBodySmall}`}>
                                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "Tuya" && smartDeviceData?.status?.length) && (<DoorLockcontroller smartDeviceData={smartDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)}></DoorLockcontroller>)}
                                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontroller ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)}></TTDoorLockcontroller>)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.AccordionList}`}>
                    <div className={`${styles.AccordionListHead} ${active === "two" ? styles.Open : ""}`} onClick={() => toggle("two")}>
                        <p className={`${styles.Title}`}>Pin Codes</p>
                        <img src="/static/img/downTriangle.svg" alt="" />
                    </div>
                    <div className={`${styles.AccordionListBody} ${active === "two" ? styles.Open : ""}`}>
                        <div className={`${styles.AccouFormGroup}`}>
                            <div className={`${styles.ControllerBodySmall}`}>
                                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontrollerPin ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} noOfSync={noOfSync} allPasswordList={allPasswordList} />)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.AccordionList}`}>
                    <div className={`${styles.AccordionListHead} ${active === "three" ? styles.Open : ""}`} onClick={() => toggle("three")}>
                        <p className={`${styles.Title}`}>Fingerprints</p>
                        <img src="/static/img/downTriangle.svg" alt="" />
                    </div>
                    <div className={`${styles.AccordionListBody} ${active === "three" ? styles.Open : ""}`}>
                        <div className={`${styles.AccouFormGroup}`}>
                            <div className={`${styles.ControllerBodySmall}`}>
                                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockcontrollerFingerprint ttLockDeviceData={ttLockDeviceData} deviceDetails={deviceDetails} setLoading={setLoading.bind(this)} noOfSync={noOfSync} fingerPrintList={fingerPrintList} setFingerPrintList={setFingerPrintList.bind(this)} />)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.AccordionList}`}>
                    <div className={`${styles.AccordionListHead} ${active === "four" ? styles.Open : ""}`} onClick={() => toggle("four")}>
                        <p className={`${styles.Title}`}>Key Fobs</p>
                        <img src="/static/img/downTriangle.svg" alt="" />
                    </div>
                    <div className={`${styles.AccordionListBody} ${active === "four" ? styles.Open : ""}`}>
                        <div className={`${styles.AccouFormGroup}`}>
                            <div className={`${styles.ControllerBodySmall}`}>
                                {(deviceDetails?.product_type === "Propertydek-Door Lock" && deviceDetails?.device_type === "TTLock") && (<TTDoorLockKeyFob setLoading={setLoading.bind(this)} deviceDetails={deviceDetails} noOfSync={noOfSync} keyList={keyList} setKeyList={setKeyList.bind(this)} />)}
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {deviceDetails?.product_type === "Propertydek-Light" && smartDeviceData?.status?.length && <div className={`${styles.AccordionList}`}>
                <div className={`${styles.AccordionListHead} ${active === "five" ? styles.Open : ""}`} onClick={() => toggle("five")}>
                    <p className={`${styles.Title}`}>Device Controller</p>
                    <img src="/static/img/downTriangle.svg" alt="" />
                </div>
                <div className={`${styles.AccordionListBody} ${active === "five" ? styles.Open : ""}`}>
                    <div className={`${styles.AccouFormGroup}`}>
                        <div className={`${styles.ControllerBodySmall}`}>
                            <Dimmercontroller smartDeviceData={smartDeviceData}></Dimmercontroller>
                        </div>
                    </div>
                </div>
            </div>}
            {deviceDetails?.product_type === "Propertydek-Thermostat" && smartDeviceData?.status?.length && <div className={`${styles.AccordionList}`}>
                <div className={`${styles.AccordionListHead} ${active === "six" ? styles.Open : ""}`} onClick={() => toggle("six")}>
                    <p className={`${styles.Title}`}>Device Controller</p>
                    <img src="/static/img/downTriangle.svg" alt="" />
                </div>
                <div className={`${styles.AccordionListBody} ${active === "six" ? styles.Open : ""}`}>
                    <div className={`${styles.AccouFormGroup}`}>
                        <div className={`${styles.ControllerBodySmall}`}>
                            <Thermostatcontroller smartDeviceData={smartDeviceData}></Thermostatcontroller>
                        </div>
                    </div>
                </div>
            </div>}

            <DeviceAlertsMobile isPanelOpen={active} onToggle={toggle.bind(this)} deviceDetails={deviceDetails} />

            {(deviceDetails?.product_type === "Propertydek-Lock Gateway") && <div className={`${styles.AccordionList}`}>
                <div className={`${styles.AccordionListHead} ${active === "eight" ? styles.Open : ""}`} onClick={() => toggle("eight")}>
                    <p className={`${styles.Title}`}>Associated Locks</p>
                    <img src="/static/img/downTriangle.svg" alt="" />
                </div>
                <div className={`${styles.AccordionListBody} ${active === "eight" ? styles.Open : ""}`}>
                    <div className={`${styles.AccouFormGroup}`}>
                        <div className={`${styles.ControllerBodySmall}`}>
                            <LockList deviceDetails={deviceDetails} />
                        </div>
                    </div>
                </div>
            </div>}

        </div>
    </div>);
}

export default SimpleTabs;